import React from 'react'
import styles from "./InfoBadge.module.css"

const InfoBadge = ({ title, children, footer }) => {
    return (
        <div
            className={styles.infoTooltipContainer}
            tabIndex={0}
            role="button"
            aria-label={title}
        >
            {/* Trigger button */}
            <button className={styles.infoBtn} tabIndex={-1} aria-hidden="true">
                i
            </button>

            {/* Tooltip bubble */}
            <div className={styles.bubble} role="tooltip">

                {/* title */}
                <div className={styles.bubbleHead}>
                    <svg
                        className={styles.bubbleHeadIcon}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                    </svg>
                    <p className={styles.bubbleHeadTitle}>{title}</p>
                </div>

                {/* Body elements */}
                <div className={styles.bubbleBody}>
                    {children}
                </div>

                {/* Footer text */}
                <p className={styles.bubbleFooter}>
                    {footer}
                </p>
            </div>
        </div>

    )
}

export default InfoBadge